import { FC, useMemo } from "react";
import { v4 as uuid } from "uuid";
import { CommonIconProps } from "../Icon/types";

const Sparkles: FC<
  CommonIconProps & {
    fillSecondary?: CommonIconProps["fill"];
  }
> = ({
  fill = "var(--icon-fill-color, #4338CA)",
  fillSecondary = "var(--icon-fill-secondary-color, #FF9BD3)",
  stroke = "var(--icon-stroke-color, none)"
}) => {
  const id = useMemo(() => uuid(), []);

  return (
    <svg
      className="icon-sparkles"
      width="100%"
      height="100%"
      viewBox="0 0 13 16"
      fill="none"
      stroke={stroke}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.8624 7.84026C10.8277 7.84025 10.7984 7.81401 10.7925 7.77882C10.6971 7.22318 10.534 6.81831 10.2623 6.53824L10.261 6.53684C9.98952 6.25705 9.59647 6.08866 9.05743 5.99034C9.0233 5.9842 8.99783 5.95404 8.99783 5.9183L8.99781 5.63629C8.99781 5.60056 9.02327 5.5704 9.0574 5.56426C9.59643 5.46601 9.98919 5.29795 10.2609 5.01792L10.2622 5.01652C10.5336 4.73676 10.6969 4.33163 10.7922 3.776C10.7982 3.74082 10.8275 3.71458 10.8621 3.71458L11.1357 3.7146C11.1704 3.7146 11.1996 3.74085 11.2056 3.77603C11.301 4.33167 11.4641 4.73654 11.7355 5.01634L11.7369 5.01773C12.0083 5.29752 12.4013 5.46591 12.9404 5.56423C12.9745 5.57038 13 5.60053 13 5.63627L13 5.91828C13 5.95402 12.9745 5.98417 12.9404 5.99031C12.4014 6.08856 12.0086 6.25662 11.7369 6.53666L11.7356 6.53805C11.4642 6.81781 11.3009 7.22294 11.2056 7.77857C11.1996 7.81375 11.1704 7.84 11.1357 7.83999L10.8624 7.84026Z"
        fill={`url(#paint0_linear_${id})`}
      />
      <path
        d="M3.0419 6.73075C2.98534 6.73074 2.93761 6.68792 2.92788 6.63053C2.77227 5.72403 2.5062 5.06352 2.06294 4.6066L2.06073 4.60432C1.6179 4.14786 0.976672 3.87315 0.097256 3.71275C0.0415744 3.70272 3.17511e-05 3.65352 2.82185e-05 3.59522L2.2531e-10 3.13514C-3.53238e-06 3.07684 0.0415338 3.02764 0.0972142 3.01762C0.97661 2.85734 1.61737 2.58316 2.06058 2.1263L2.06279 2.12402C2.50556 1.66762 2.77199 1.00668 2.92749 0.100207C2.93721 0.0428126 2.98493 -3.64115e-06 3.04149 2.32248e-10L3.48783 2.91001e-05C3.54439 3.27415e-05 3.59212 0.0428544 3.60185 0.10025C3.75745 1.00674 4.02353 1.66726 4.46635 2.12372L4.46856 2.126C4.91138 2.58246 5.55261 2.85718 6.43203 3.01758C6.48771 3.0276 6.52925 3.0768 6.52926 3.13511L6.52929 3.59518C6.52929 3.65349 6.48775 3.70268 6.43207 3.7127C5.55268 3.87299 4.91192 4.14717 4.46871 4.60402L4.4665 4.6063C4.02373 5.0627 3.7573 5.72364 3.6018 6.63012C3.59208 6.68751 3.54436 6.73033 3.48779 6.73032L3.0419 6.73075Z"
        fill={`url(#paint1_linear_${id})`}
      />
      <path
        d="M6.49626 16C6.40373 16 6.32565 15.93 6.30975 15.8361C6.05527 14.3532 5.62007 13.2726 4.89498 12.5252L4.89136 12.5215C4.167 11.7748 3.11804 11.3255 1.67943 11.0632C1.58834 11.0468 1.52039 10.9663 1.52039 10.8709L1.52038 10.1183C1.52038 10.0229 1.58834 9.94243 1.67943 9.92604C3.11803 9.66374 4.16626 9.21515 4.89134 8.46775L4.89495 8.46402C5.61931 7.71736 6.05523 6.63611 6.30968 5.15321C6.32559 5.05932 6.40366 4.98927 6.4962 4.98927L7.22634 4.98928C7.31888 4.98928 7.39695 5.05933 7.41286 5.15322C7.66733 6.63612 8.10254 7.71663 8.8269 8.4633L8.83052 8.46703C9.55489 9.2137 10.6038 9.66305 12.0425 9.92536C12.1335 9.94175 12.2015 10.0222 12.2015 10.1176L12.2015 10.8702C12.2015 10.9656 12.1335 11.0461 12.0425 11.0625C10.6039 11.3248 9.55562 11.7734 8.83054 12.5208L8.82693 12.5245C8.10257 13.2712 7.66666 14.3524 7.4122 15.8353C7.3963 15.9292 7.31822 15.9993 7.22569 15.9993L6.49554 15.9993L6.49626 16Z"
        fill={`url(#paint2_linear_${id})`}
      />
      <defs>
        <linearGradient
          id={`paint0_linear_${id}`}
          x1="0.140541"
          y1="8"
          x2="12.7524"
          y2="8.07429"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor={fill} />
          <stop offset="0.85" stopColor={fillSecondary} />
        </linearGradient>
        <linearGradient
          id={`paint1_linear_${id}`}
          x1="0.140541"
          y1="8"
          x2="12.7524"
          y2="8.07429"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor={fill} />
          <stop offset="0.85" stopColor={fillSecondary} />
        </linearGradient>
        <linearGradient
          id={`paint2_linear_${id}`}
          x1="0.140541"
          y1="8"
          x2="12.7524"
          y2="8.07429"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor={fill} />
          <stop offset="0.85" stopColor={fillSecondary} />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default Sparkles;
